import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { finalize } from 'rxjs';
import { IndexService } from '../../services/index.service';
import { ModalComponent } from '../../shared/modal/modal.component';
import { SearchBarComponent } from "../../shared/searchbar/searchbar.component";
import { SharedTableComponent } from "../../shared/shared-table/shared-table.component";

@Component({
  selector: 'app-indici',
  standalone: true,
  templateUrl: './indici.component.html',
  styleUrls: ['./indici.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    SharedTableComponent,
    SearchBarComponent
]
})
export class IndiciComponent implements OnInit {
  
    constructor(private readonly dialog: MatDialog, private readonly indexService: IndexService ){}
    
    isLoading = false;
    hasError = false;
    sortBy = 'name:asc';
    sortField = "";
    sortDirection = "";
    searchQuery: string = "";

    dataSourceIndexes = new MatTableDataSource<any>();

    // Paginazione server-side
    pageIndex = 0;
    pageSize = 10;
    totalItems = 0;

    ngOnInit(): void {
      this.loadIndexList(this.pageIndex, this.pageSize, this.sortBy, this.searchQuery);
    }

    loadIndexList(pageIndex: number, pageSize: number, sortBy: string, indexFilter: string){
     this.isLoading = true;
     this.hasError = false;
     this.indexService.getIndexList(pageIndex, pageSize, sortBy, indexFilter).pipe(finalize(() => { this.isLoading = false; })).subscribe({
      next: (response) => {
        this.dataSourceIndexes.data = response.content;
        this.totalItems = response.totalElements;

         // allinea lo stato locale con quanto ritorna il BE
        this.pageIndex = (response?.number ?? pageIndex) ?? 0;
        this.pageSize  = (response?.size ?? pageSize) ?? this.pageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceIndexes.data = [];
        this.totalItems = 0;
        this.hasError = true;
      }
    })
  }

  onFilterChanged(value: any) {
    this.searchQuery = value.name;
    console.log("value filtro", value.name);
    this.pageIndex = 0;
    this.loadIndexList(this.pageIndex, this.pageSize, "name:asc", this.searchQuery);
  }

  onSortChanged(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || "asc";
    this.sortBy = `${this.sortField}:${this.sortDirection}`;
    console.log("ordinamento", this.sortBy);
    this.pageIndex = 0;
    this.loadIndexList(this.pageIndex, this.pageSize, this.sortBy, this.searchQuery);
  }

  // Cambio pagina / page size dal paginator (server-side)
  onPageChanged(ev: PageEvent) {
    this.pageIndex = ev.pageIndex;
    this.pageSize = ev.pageSize;
    this.loadIndexList(this.pageIndex, this.pageSize, this.sortBy, this.searchQuery);
  }

  openDialog(event : {data: any, type: 'add' | 'edit' | 'delete'}){
      
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '400px',
      data: {
        action: event.type,
        payload: event.data
      } 
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          if (event.type === 'delete'){
            this.indexService.deleteIndex(result.id).subscribe({
              next: () => {
                this.loadIndexList(this.pageIndex, this.pageSize, this.sortBy, this.searchQuery);
              },
              error: (err) => {
                console.log("errore nella richiesta", err);
              }
            });
          }
        }
      });
    }
}